import moment from 'moment';

import { sxStyle } from './styles';
import { TextPartsLayout } from './TextPartsLayout';

export const RefundableInfo = ({
  index,
  check_in,
  cancelationFee,
  isaBuying,
  containerStyle,
  layout = 'stacked',
}) => {
  const deadline = moment(check_in).subtract(
    +cancelationFee?.DeadLineCancel,
    'days'
  );
  const fechaCancel = deadline.format('DD/MM/YYYY');

  const parts = [
    {
      key: 'title',
      text: 'Reembolsable',
      sx: sxStyle.seeRefundability,
    },
    {
      key: 'text',
      text: `Podés cancelar ${isaBuying ? '' : 'gratis '}hasta el`,
      sx: sxStyle.seeToRefundability,
    },
    {
      key: 'date',
      text: `${fechaCancel}${isaBuying ? '. Consultar condiciones' : ''}`,
      sx: sxStyle.seeSubRefundability,
    },
  ];

  return (
    <TextPartsLayout
      parts={parts}
      layout={layout}
      containerStyle={containerStyle}
      inlineTypographyId={`refundableInline-${index}`}
    />
  );
};
